// TODO: rename to BenefitSummary
export class BenefitSummaryList {
	showCafeteriaSummaryTotal: boolean;
	showSummaryTotal: boolean;
	summaryBenefitCards: BenefitSummary[];
	summaryTotalCards: BenefitTotal[];
	cafeteriaSummaryTotalCard: CafeteriaSummaryTotalCard;
	messageHTML: string;

	constructor() {
		this.showCafeteriaSummaryTotal = false;
		this.showSummaryTotal = false;
		this.summaryBenefitCards = new Array<BenefitSummary>();
		this.summaryTotalCards = new Array<BenefitTotal>();
		this.messageHTML = null;
	}
}

export class BenefitSummary {
	uniqueID: string;
	categoryId: number;
	categoryForDisplay: string;
	materialIconName: string;
	showCategory: boolean;
	enrollmentName: string;
	tier: string;
	effectiveDate: string;
	terminationDate: string;
	deductionForDisplay: string;
	deductionAmount: number;
	processInfo: string;
	isPretax: boolean;
	isTermed: boolean;
	frequency: number;
	enrollRequestId: number;
	showModal: boolean;
	coveredMembers: BenefitCoveredMember[];
	requestedEOIs: RequestedEOI[];

	constructor() {
		this.uniqueID = null;
		this.categoryId = 0;
		this.categoryForDisplay = null;
		this.materialIconName = null;
		this.showCategory = false;
		this.enrollmentName = null;
		this.tier = null;
		this.effectiveDate = null;
		this.terminationDate = null;
		this.deductionForDisplay = null;
		this.deductionAmount = 0;
		this.processInfo = null;
		this.isPretax = false;
		this.isTermed = false;
		this.frequency = 0;
		this.enrollRequestId = 0;
		this.showModal = false;
		this.coveredMembers = [];
		this.requestedEOIs = [];
	}
}

export class BenefitCoveredMember {
	name: string;
	relationship: string;
	effectiveDate: string;
	terminationDate: string;
	processInfo: string;
	disabledMessage: string;

	constructor() {
		this.name = null;
		this.relationship = null;
		this.effectiveDate = null;
		this.terminationDate = null;
		this.processInfo = null;
		this.disabledMessage = null;
	}
}

export class RequestedEOI {
	tier: string;
	effectiveDate: string;
	terminationDate: string;
	deductionForDisplay: string;
	deductionAmount: number;
	tobaccoRated: string;
	age: string;
	pendingUnderwriting: string;
	approved: string;
	pendUnderWriting: boolean;

	constructor() {
		this.tier = null;
		this.effectiveDate = null;
		this.terminationDate = null;
		this.deductionForDisplay = null;
		this.deductionAmount = 0;
		this.tobaccoRated = null;
		this.age = null;
		this.pendingUnderwriting = null;
		this.approved = null;
		this.pendUnderWriting = false;
	}
}

export class BenefitTotal {
	frequency: number;
	frequencyDisplay: string;
	totalCost: number;
	totalPosttax: number;
	totalPretax: number;

	constructor() {
		this.frequency = 0;
		this.frequencyDisplay = null;
		this.totalCost = 0;
		this.totalPosttax = 0;
		this.totalPretax = 0;
	}
}

// TODO: WTF does CafeteriaSummaryTotalCard do?
export class CafeteriaSummaryTotalCard {
	coreEmployeeAmount: number;
	coreEmployerAmount: number;
	coreFrequencyDisplay: string;
	fsaAmount: number;
	fsaFrequencyDisplay: string;
	totalCoreAmount: number;
	totalVoluntaryAmount: number;
	voluntaryFrequencyDisplay: string;
	voluntaryPosttaxAmount: number;
	voluntaryPretaxAmount: number;
	showCoreOnly: boolean;
	coreEmployeeTaxStatus: string;

	constructor() {
		this.coreEmployeeAmount = 0;
		this.coreEmployerAmount = 0;
		this.coreFrequencyDisplay = null;
		this.fsaAmount = 0;
		this.fsaFrequencyDisplay = null;
		this.totalCoreAmount = 0;
		this.totalVoluntaryAmount = 0;
		this.voluntaryFrequencyDisplay = null;
		this.voluntaryPosttaxAmount = 0;
		this.voluntaryPretaxAmount = 0;
		this.showCoreOnly = false;
		this.coreEmployeeTaxStatus = null;
	}
}

export class CancelBenefit {
	cancelRequestItems: CancelRequestItems[];

	constructor() {
		this.cancelRequestItems = new Array<CancelRequestItems>();
	}
}

export class CancelRequestItems {
	benefitName: string;
	benefitNumber: number;
	process: string;
	requestDate: string;

	constructor() {
		this.benefitName = null;
		this.benefitNumber = 0;
		this.process = null;
		this.requestDate = null;
	}
}

export class CoveredMemberDialogModel {
	benefitName: string;
	coveredMembers: BenefitCoveredMember[];

	constructor() {
		this.benefitName = null;
		this.coveredMembers = new Array<BenefitCoveredMember>();
	}
}

export class BenefitSummaryItemList {
	benefitSummaryItems: BenefitSummaryItem[];

	constructor() {
		this.benefitSummaryItems = new Array<BenefitSummaryItem>();
	}
}

export class BenefitSummaryItem {
	benefitSummaryID: number;
	fileName: string;
	linkText: string;
	fileType: string;
	createdOn: string;

	constructor() {
		this.benefitSummaryID = 0;
		this.fileName = null;
		this.linkText = null;
		this.fileType = null;
		this.createdOn = null;
	}
}
export class BenefitSummaryEmailCriteria {
	toAddress: string;
	benefitSummaryID: number;
	constructor() {
		this.benefitSummaryID = 0;
		this.toAddress = null;
	}
}